import { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { VideoBlockUrls, Refresh, VideoCap, TwoVideosPlace } from 'libs/ui';

export const AppVideos = (props) => {
  const { cams, id, cl } = props;
  const [createtime, setCreatetime] = useState(1);
  const { t } = useTranslation();

  const updateTime = () => {
    const createtime = moment().unix();
    setCreatetime(createtime);
  };

  useEffect(() => {
    updateTime();
  }, []);

  /**
   * refresh video
   */
  const refresh = () => {
    updateTime();
  };

  // if no cams
  if (cams === null || !cams.length) {
    return (
      <VideoCap
        className={cl}
        $status={t('clarifications.отключен')}
        style={{
          height: '310px',
          width: '500px',
        }}
      />
    );
  }

  return (
    <TwoVideosPlace>
      <Refresh onClick={refresh} />
      <VideoBlockUrls
        createtime={createtime}
        rackId={id}
        type="one_doubled"
        camHeight="310px"
        //cams={["face", "main"]}
        cams={cams}
      />
    </TwoVideosPlace>
  );
};
